import axios from 'axios'
import { Message } from 'element-ui';
import router from '../router'
// 请求超时时间
axios.defaults.timeout = 600000;

const BASE_URL = 'http://43.136.108.67:5000'
// const BASE_URL = 'http://s5.z100.vip:16108'

// axios.interceptors.request.use(
//   config => {
//     return config;
//   },
//   error => {
//     return Promise.error(error);
//   });


// http response 拦截器
// axios.interceptors.response.use(
//   response => {
//     if (response.data.code == 10006 || response.data.message == '登录失败') {
//       router.push({
//         path: '/login',
//       })
//       this.$message.error(response.data.message)
//     }
//     return response;
//   },
//   error => {
//     return Promise.reject(error.response.data)
//   });

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(`${BASE_URL}/${url}`,
      {
        params: params
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data);
      })
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(`${BASE_URL}/${url}`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data);
      })
  });
}



export { axios, BASE_URL }